export interface LocalizedText {
  en: string;
  ar?: string;
}

export interface ChoiceOption {
  id: string;
  name: LocalizedText;
  priceModifier?: number;
}

export interface ChoiceGroup {
  id: string;
  name: LocalizedText;
  options: ChoiceOption[];
  required: boolean;
  optional: boolean;
  min: number;
  max: number;
}

export interface MenuItem {
  id: string;
  name: LocalizedText;
  description: LocalizedText;
  price: number;
  image?: string;
  imageNotAvailable?: boolean;
  note?: LocalizedText;
  choiceGroups: ChoiceGroup[];
}

export interface MenuCategory {
  id: string;
  name: LocalizedText;
  items: MenuItem[];
}

export interface MenuData {
  title: LocalizedText;
  logo?: string; // URL to the logo image
  status?: 'live' | 'offline';
  categories: MenuCategory[];
  languages?: string[];
  currency?: string;
}

export interface Brand {
  id: string;
  name: string;
  logo?: string;
}

export interface MenuMetadata {
  id: string;
  brandId: string;
  name: string;
  logo?: string;
  status?: 'live' | 'offline';
  itemCount?: number;
  languages?: string[];
  updatedAt?: string;
}

// Drag Types
export type DragId = string;
export type DragType = 'CATEGORY' | 'ITEM';

// Ordering Types
export interface SelectedOption {
  groupId: string;
  optionId: string;
  name: LocalizedText;
  price: number;
}

export interface CartItem {
  id: string; // Unique instance ID
  menuItem: MenuItem;
  selectedOptions: SelectedOption[];
  quantity: number;
  totalPrice: number; // Unit price * quantity
  unitPrice: number; // Base + Options
}

export const validateItem = (item: MenuItem): string[] => {
  const errors: string[] = [];
  if (!item.name.en) errors.push("Missing English Name");
  if (!item.name.ar) errors.push("Missing Arabic Name");
  if (!item.description.en) errors.push("Missing English Description");
  if (!item.description.ar) errors.push("Missing Arabic Description");
  if (!item.image && !item.imageNotAvailable) errors.push("Missing Image");
  return errors;
};